import React from 'react';
import { Box, styled, Typography, Button } from '@mui/material';
import { ReactComponent as AlertIcon } from '../../assets/images/alert-circle.svg';
import { ReactComponent as RefreshIcon } from '../../assets/images/refresh-icon.svg';
import { commonLabels } from '../../utils/CommonLabels';

const ErrorContentContainer = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	flexDirection: 'column',
});
interface ErrorContentProps {
	height?: string;
	handleRefresh?: () => void;
}

export const ErrorContent: React.FC<ErrorContentProps> = ({
	height = '300px',
	handleRefresh,
}) => {
	return (
		<ErrorContentContainer sx={{ height: height }}>
			<AlertIcon data-testid="AlertIcon" />
			<Typography variant="h3" sx={{ marginTop: '8px' }}>
				{commonLabels.refreshTxt}
			</Typography>
			<Typography variant="body2" sx={{ marginBottom: '8px' }}>
				{commonLabels.refreshHint}
			</Typography>
			<Button
				data-testid="Refresh-Button"
				variant="contained"
				color="primary"
				component="span"
				endIcon={<RefreshIcon data-testid="RefreshIcon" />}
				onClick={handleRefresh}
			>
				{commonLabels.refresh}
			</Button>
		</ErrorContentContainer>
	);
};

export default ErrorContent;
